export default {"src":"/_next/static/media/instagram-icon.85d44c1f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};